import { Collector } from '@mss/mss-component-library';

export const intervalOffset = (minutes: number | string) => {
  let min = typeof minutes === 'string' ? parseInt(minutes) : minutes;

  if (min >= 60) return 'hours';
  return 'minutes';
};

export const collectorFactory = (
  label: string,
  collector_key: string,
  collector_type: string,
  defaultInterval: number
): Collector => {
  return {
    id: null,
    collector_key,
    collector_type,
    label,
    last_run_at: null,
    next_run_at: null,
    last_run_str: '',
    next_run_str: '',
    last_result_log: null,
    last_result: null,
    enabled: false,
    interval: 0,
    defaultInterval,
  };
};
